import React, {Fragment} from 'react'
import {strVal} from '../../../modules/Utils'
import style from '../../../components/Sales/Payments/style.css'

export default function HeaderCardDetails({projectId, program, owner}) {
  return (
    <Fragment>
      <h1 style={{marginTop: 20}} className={style.title}>
        {strVal(owner, 'project.title')}
      </h1>
      <div className={style.paragraph}>
        <p>
          <b>Category</b> : {strVal(owner, 'project.category').toUpperCase()}
        </p>
        <p className="paragraph">
          <b>Program Type</b> :{' '}
          {strVal(owner, 'project.projectType').toUpperCase()}
        </p>
      </div>
    </Fragment>
  )
}
